export enum TEMPLATE_MODEL {
  SHARED = 'Shared',
  PRIVATE = 'Private',
  DEFAULT = 'Default'
}
